import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SVGIcon, arrowRotateCwIcon, downloadIcon } from '@progress/kendo-svg-icons';

import { CFAttachmentFile } from '../../../models/attachments/cf-attachment-file';
import { CFFile } from '../../../models/attachments/cf-file';

@UntilDestroy()
@Component({
    selector: 'clfl-attachment-files-tab',
    templateUrl: './attachment-files-tab.component.html',
    styleUrls: ['./attachment-files-tab.component.scss']
})
export class AttachmentFilesTabComponent implements OnChanges {
    @Input()
    public attachmentFiles!: Array<CFAttachmentFile>;

    @Output() onRefresh: EventEmitter<void> = new EventEmitter();
    @Output() onFileDownload: EventEmitter<CFFile> = new EventEmitter();

    public downloadIcon: SVGIcon = downloadIcon;
    public arrowRotateCwIcon: SVGIcon = arrowRotateCwIcon;
    public refreshing = false;

    ngOnChanges(): void {
        this.refreshing = false;
    }

    public downloadFile(file: CFAttachmentFile) {
        this.onFileDownload.emit(file.attachment);
    }

    public refreshFiles() {
        this.onRefresh.emit();
        this.refreshing = true;
    }
}
